// extracted by mini-css-extract-plugin
export default {"brandsLeagueList":"index_brandsLeagueList_nejVB","listItem":"index_listItem_Vimxx","brands_content":"index_brands_content_nPKto","brands_logo":"index_brands_logo_7QZMz"};